<template>

    <router-view></router-view>

</template>

<script>

    import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';
    import Store from '../store';
    import {mapActions} from 'vuex';

    export default {

        mixins: [activeSessionChecker],

        methods: {
            ...mapActions('SubPanels', [
                'loadSubPanels',
            ]),
        },

        created() {
            if (!this.$store.state.SubPanels) {
                this.$store.registerModule('SubPanels', Store);
            }

            if (this.hasPermission('view sub panels')) {
                this.loadSubPanels();
            }
        },
    }

</script>
